var map = {
	"./logo_agote.png": 1058,
	"./logo_agote_color.png": 1059,
	"./logo_altos.png": 1060,
	"./logo_altos_color.png": 1061,
	"./logo_arcos.png": 1062,
	"./logo_arcos_color.png": 1063,
	"./logo_art.png": 1064,
	"./logo_art_color.png": 1065,
	"./logo_blue.png": 1066,
	"./logo_blue_color.png": 1067,
	"./logo_cells.png": 1068,
	"./logo_cells_color.png": 1069,
	"./logo_cymsa.png": 1070,
	"./logo_cymsa_color.png": 1071,
	"./logo_ecco.png": 1072,
	"./logo_ecco_color.png": 1073,
	"./logo_fundacion.png": 1074,
	"./logo_fundacion_color.png": 1075,
	"./logo_life.png": 1076,
	"./logo_life_color.png": 1077,
	"./logo_maternidad.png": 1078,
	"./logo_maternidad_color.png": 1079,
	"./logo_olivos.png": 1080,
	"./logo_olivos_color.png": 1081,
	"./logo_qualitas.png": 1082,
	"./logo_qualitas_color.png": 1083,
	"./logo_salta.png": 1084,
	"./logo_salta_color.png": 1085,
	"./logo_sanlucas.png": 1086,
	"./logo_sanlucas_color.png": 1087,
	"./logo_seguros.png": 1088,
	"./logo_seguros_color.png": 1089,
	"./logo_smc.png": 1090,
	"./logo_smc_color.png": 1091,
	"./logo_smmp.png": 1092,
	"./logo_smmp_color.png": 1093,
	"./logo_travel.png": 1094,
	"./logo_travel_color.png": 1095,
	"./logo_zabala.png": 1096,
	"./logo_zabala_color.png": 1097
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1057;


//////////////////
// WEBPACK FOOTER
// ./src/components/Carousel/images nonrecursive \.png
// module id = 1057
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13